import { Injectable, Injector } from "@angular/core";
import { BaseHttpService } from "./base-http.service";
import { FileState, FileInfo } from "@progress/kendo-angular-upload";
import { config } from "../../config/config";
import { utilities } from "../../modules/utility";

@Injectable()
export class S3Service extends BaseHttpService {

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * Construct url and call S3 service to remove file
     * @param file - file to remove
     * @param path - path to file e.g (CTWR/12345/)
     */
    handleS3Remove(file, path): Promise<any> {
        let url = s3config.baseUrl[utilities.getEnv()] + s3config.methods.delete + s3config.s3Bucket[utilities.getEnv()]
            + '&s3ObjectKey=' + path + file.name;
        return this.removeS3Object(url)
            .catch(this.handleError)
    }


    /**
     * Construct url and call s3 Service to copy file (recursive)
     * Attach body with source/destination info
     * @param file 
     * @param sourcePath 
     * @param destinationPath 
     */
    handleS3Copy(files: FileInfo[], sourcePath: string, destinationPath: string): Promise<any> {
        let _file: FileInfo = files.find(f => f.state < 3);
        if (!_file) return Promise.resolve();

        let url = s3config.baseUrl[utilities.getEnv()] + s3config.methods.copy;
        let json = {
            SourceBucket: s3config.s3Bucket,
            SourceObject: sourcePath + _file.name,
            DestinationBucket: s3config.s3Bucket,
            DestinationObject: destinationPath + _file.name,
        }

        if (_file.state !== FileState.Uploaded) {
            return this.copyS3Object(JSON.stringify(json), url)
                .then(x => _file.state = FileState.Uploaded)
                .then(x => this.handleS3Copy(files, sourcePath, destinationPath))
                .catch(this.handleError)
        } else {
            return this.handleS3Copy(files, sourcePath, destinationPath);
        }
    }


    /**
     * Construct url and call S3 service to upload file (recursive)
     * @param files - List of files to upload
     * @param path - S3 path to file e.g.(CTWR/12345/)
     */
    handleS3Upload(files: FileInfo[], path: string): Promise<any> {
        let _file: FileInfo = files.find(f => f.state < 3);
        if (!_file) return Promise.resolve();

        let formData: FormData = new FormData();
        formData.append('file', _file.rawFile);
        let url = s3config.baseUrl[utilities.getEnv()] + s3config.methods.upload + s3config.s3Bucket[utilities.getEnv()]
            + '&s3ObjectKey=' + path + _file.name;

        if (_file.state !== FileState.Uploaded) {
            return this.uploadS3Object(formData, url)
                .then(x => _file.state = FileState.Uploaded)
                .then(x => this.handleS3Upload(files, path))
                .catch(this.handleError)
        } else {
            return this.handleS3Upload(files, path);
        }
    }


    /**
     * Construct url and call S3 service to upload file
     * @param file - byte array
     * @param path - S3 path to file e.g.(CTWR/12345/filename.ext)
     */
    uploadS3ByteArray(formData: FormData, path: string): Promise<any> {
        let url = s3config.baseUrl[utilities.getEnv()] + s3config.methods.upload + s3config.s3Bucket[utilities.getEnv()]
            + '&s3ObjectKey=' + path;
        return this.uploadS3Object(formData, url);
    }


    getS3Url(path, filename) {
        return s3config.baseUrl[utilities.getEnv()] + s3config.methods.upload + s3config.s3Bucket[utilities.getEnv()]
            + '&s3ObjectKey=' + path + filename;
    }


    /**
     * 
     * @param filePath: e.g.(CTWR/12345/)
     */
    downloadS3Object = (file: FileInfo, path) => {
        if (!path) return;
        let url = s3config.baseUrl[utilities.getEnv()] + s3config.methods.get + s3config.s3Bucket[utilities.getEnv()]
            + '&s3ObjectKey=' + path + file.name;
        this.getS3Object(url)
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = file.name;
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            })
            .catch(this.handleError)
    }


    /**
     * Generate S3 URL
     * param
     * filePath: Path to file in s3 bucket ex) 'PHF/PressPictures/fileName.jpg'
     */
    getS3Path = (filePath: string): string => {
        let extension = filePath.split('.')[1] == 'gif' ? 'gif' : 'jpeg';
        return s3config.baseUrl[utilities.getEnv()] + s3config.methods.bytes + s3config.s3Bucket[utilities.getEnv()]
            + '&s3ObjectKey=' + filePath + '&mediaTypeHeader=image/' + extension;
    }
}

const testBucket = 'b0173294-002';
const testURL = "https://cgp-s3-test.apps.pcfepg2wi.gm.com";
export const s3config = {
    baseUrl: {
        "LOCAL": testURL,
        "DEV": testURL,
        "QA": testURL,
        "TEST": testURL,
        "TEST_COPY": testURL,
        "PROD": "https://cgp-s3.ocp-prod2im1.gm.com",
    },
    s3Bucket: {
        "LOCAL": testBucket,
        "DEV": testBucket,
        "QA": testBucket,
        "TEST": testBucket,
        "TEST_COPY": testBucket,
        "PROD": "b0173294-001",
    },
    methods: {
        copy: '/CopyS3Object',
        delete: '/DeleteS3Object?s3Bucket=',
        get: '/GetS3Object?s3Bucket=',
        bytes: '/GetS3ObjectBytes?appId=mesc2&s3Bucket=',
        upload: '/UploadFile?s3Bucket=',
    },
}
